export const initialState = {
  isDashboardLoading: true,
};

export function SET_LOADING_APP_MODE_OVERVIEW(nextState, { guid, isLoading }) {
  nextState.isDashboardLoading = isLoading;
}
